import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";

import { submitInputData } from "../../shared/apis/mainAPI";
import { InputDataContext } from "../../shared/contexts/InputDataContext";
import { OutputDataContext } from "../../App";
import classes from "./CalculateButtonRedundancy.module.css";


const CalculateButton = () => {

  const navigate = useNavigate();
  const { inputsRef } = useContext(InputDataContext);
  

  const { outputDataRef } = useContext(OutputDataContext);

  const handleSubmit = async () => {
    try {
      const data = await submitInputData(inputsRef.current);
      outputDataRef.current = data;
      navigate("/Redundancy");
    } catch (error) {
      console.error("Error in handleSubmit:", error);
      // Handle any errors that might occur during handleSubmit
    }
  };


  return (
    <button className={classes.pagebutton} onClick={handleSubmit}>
      Calculate
    </button>
  );
};

export default CalculateButton;


  


